import { type FeatureExpansionRequestType } from '@webapp/core/services/Marketo'
import { NAVATTIC_CAPTURE_BASE_URL, PRODUCT_TOUR_DEMO_IDS } from '../constants'

export const buildProductTourUrl = (
  context: FeatureExpansionRequestType
): string | undefined => {
  const demoId = PRODUCT_TOUR_DEMO_IDS[context]

  if (!demoId) {
    return undefined
  }

  return `${NAVATTIC_CAPTURE_BASE_URL}/${encodeURIComponent(demoId)}`
}
